export const emailCampaignMailsKeys = {
	all: ['emailCampaignMails'],
	byCampaign: (campaignId) => ['emailCampaignMails', 'byCampaign', campaignId],
};

export const emailCampaignMailsMutationKeys = {
	insert: ['emailCampaignMails', 'insert'],
	update: ['emailCampaignMails', 'update'],
	delete: ['emailCampaignMails', 'delete'],
};
